import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BackButton from "../components/ui/BackButton";
import {
  adminupload,
  getDocument,
  getprofiledetail,
  updatestaus,
} from "../Redux/Action/CareSeekerAction";
import {
  downloadUserVerificationData,
  getUserVerificationDetails
} from "../Redux/Action/VerificationAction";
import DeleteModal from "../Component/DeleteModal";
import BlockModal from "../Component/BlockModal";
import ImageModal from "../Component/ImageModal";
import AlternativeContactModal from "../components/ui/ContactEditModal";
import EditDropdown from "../components/ui/EditDropdown";
import EmailHistorySection from "../components/ui/EmailHistorySection";
import Flag from "react-flagkit";
import Contry from "../Component/Contry";
import FirstLetterCapital from "../CustomHooks/FirstLetterCapital";
import { bookinlist } from "../Redux/Action/BookingAction";
import { getOptimizedImageUrl, IMAGE_SIZES } from "../utils/imageOptimization";

export default function UserDetails({ role: propRole }) {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  // Determine role from prop or route
  let role = propRole;
  if (!role) {
    if (location.pathname.startsWith("/carer-details")) role = "carer";
    else if (location.pathname.startsWith("/profile-details")) role = "care seeker";
  }

  // Redux selectors - moved to top to prevent initialization issues
  const getprofiledetails = useSelector(
    (state) => state?.careseeker?.getprofiledetail || {}
  );

  // Verification selectors
  const verificationState = useSelector((state) => state?.Verification || {});
  const {
    downloadLoading,
    downloadError,
    downloadSuccess,
    verificationDetails,
    verificationLoading,
    verificationError
  } = verificationState;

  // State variables
  const [id_proof, setid_proof] = useState(null);
  const [document, setDocument] = useState(null);
  const [show, setShow] = useState(false);
  const [infoid, setInfoId] = useState(null);
  const [type, setType] = useState(null);
  const [showblock, setShowblock] = useState(false);
  const [title, settitle] = useState(false);
  const [address_proof, setaddress_proof] = useState(null);
  const [userBookings, setUserBookings] = useState([]);
  const [bookingsLoading, setBookingsLoading] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState({ url: '', alt: '' });
  const [showVerificationSection, setShowVerificationSection] = useState(false);
  const [showAlternativeContactModal, setShowAlternativeContactModal] = useState(false);
  const [contactEditType, setContactEditType] = useState('alternative');
  const [showEmailHistory, setShowEmailHistory] = useState(false);

  // Main data loading effect
  useEffect(() => {
    const loadData = async () => {
      if (!id) return;
      
      try {
        console.log("Starting to load user data for ID:", id);
        
        // Load profile details and documents in parallel
        const [, documentResult] = await Promise.all([
          dispatch(getprofiledetail({ id })),
          dispatch(getDocument())
        ]);
        
        console.log("Profile and document data loaded successfully");
        setDocument(documentResult.payload);
        setDataLoaded(true);
        
        // Load bookings separately (non-blocking)
        setBookingsLoading(true);
        const filterKey = role === "carer" ? "carer_id" : "user_id";
        Promise.all([
          dispatch(bookinlist({ search: "", status: "carer_assigned", [filterKey]: id, page: 1, limit: 10 })),
          dispatch(bookinlist({ search: "", status: "payment_confirmed", [filterKey]: id, page: 1, limit: 10 }))
        ]).then(([assigned, confirmed]) => {
          setUserBookings([
            ...(assigned.payload?.data || []),
            ...(confirmed.payload?.data || [])
          ]);
          setBookingsLoading(false);
        }).catch((error) => {
          console.error("Error loading bookings:", error);
          setBookingsLoading(false);
        });
        
      } catch (error) {
        console.error("Error loading user data:", error);
        setDataLoaded(true); // Set to true even on error to show the page
      }
    };
    
    loadData();
  }, [dispatch, id, role]);

  // Show success/error messages for download
  useEffect(() => {
    if (downloadSuccess) {
      // You can add a toast notification here if you have one
      console.log("Verification data downloaded successfully");
    }
    if (downloadError) {
      // You can add a toast notification here if you have one
      console.error("Download error:", downloadError);
    }
  }, [downloadSuccess, downloadError]);

  // Early return if no ID is provided
  if (!id) {
    return (
      <Layout>
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <h3>Invalid User ID</h3>
          <p>No user ID provided in the URL.</p>
        </div>
      </Layout>
    );
  }

  // Show loading state until data is loaded
  if (!dataLoaded) {
    return (
      <Layout>
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <div style={{ display: 'inline-block', width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #3498db', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
          <p style={{ marginTop: '20px' }}>Loading user details...</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </Layout>
    );
  }

  const handleidproofUpload = async (event, idinfo) => {
    const file = event.target.files[0];
    if (!file) return;
    
    try {
      let fileinfo = new FormData();
      fileinfo.append("file", file);
      
      const uploadResult = await dispatch(adminupload(fileinfo));
      let id_proof = {
        id: idinfo,
        picture: uploadResult.payload.url,
      };
      
      await dispatch(updatestaus({ userId: id, id_proof: id_proof }));
      setid_proof(uploadResult.payload.url);
      await dispatch(getprofiledetail({ id }));
    } catch (error) {
      console.error("Error uploading ID proof:", error);
    }
  };

  const handleaddressproofUpload = async (event, idinfo) => {
    const file = event.target.files[0];
    if (!file) return;
    
    try {
      let fileinfo = new FormData();
      fileinfo.append("file", file);
      
      const uploadResult = await dispatch(adminupload(fileinfo));
      let address_proof = {
        id: idinfo,
        picture: uploadResult.payload.url,
      };
      
      await dispatch(updatestaus({ userId: id, address_proof: address_proof }));
      await dispatch(getprofiledetail({ id }));
      setaddress_proof(uploadResult.payload.url);
    } catch (error) {
      console.error("Error uploading address proof:", error);
    }
  };

  const handleDelete = async () => {
    try {
      let address_proof = {
        id: infoid,
        picture: "https://imgbb.com/",
      };
      await dispatch(
        type === "Passport"
          ? updatestaus({ userId: id, id_proof: address_proof })
          : updatestaus({ userId: id, address_proof: address_proof })
      );
      type === "Passport" ? setid_proof(null) : setaddress_proof(null);
      setShow(false);
      await dispatch(getprofiledetail({ id }));
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };

  function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return isNaN(age) === true ? "N/A" : age;
  }

  const handleBlockActive = async () => {
    if (!getprofiledetails?._id) {
      console.error("Profile details not available");
      return;
    }
    
    try {
      await dispatch(
        updatestaus({
          userId: getprofiledetails._id,
          is_active: getprofiledetails.is_active === true ? false : true,
        })
      );
      await dispatch(getprofiledetail({ id }));
      setShowblock(false);
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  const handleImageClick = (imageUrl, altText) => {
    if (imageUrl && imageUrl !== '/default-avatar.png') {
      setSelectedImage({ url: imageUrl, alt: altText });
      setShowImageModal(true);
    }
  };

  // Handle verification data download
  const handleDownloadVerificationData = async () => {
    try {
      await dispatch(downloadUserVerificationData(id));
    } catch (error) {
      console.error("Error downloading verification data:", error);
    }
  };

  // Load verification details when verification section is expanded
  const handleEditContact = (editType) => {
    setContactEditType(editType);
    setShowAlternativeContactModal(true);
  };

  const handleToggleVerificationSection = async () => {
    if (!showVerificationSection && !verificationDetails) {
      try {
        await dispatch(getUserVerificationDetails(id));
      } catch (error) {
        console.error("Error loading verification details:", error);
      }
    }
    setShowVerificationSection(!showVerificationSection);
  };

  return (
    <Layout>
      {/* Breadcrumb */}
      <div style={{ 
        padding: '12px 20px', 
        backgroundColor: '#f8f9fa', 
        borderBottom: '1px solid #dee2e6',
        marginBottom: '20px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <BackButton />
          <nav style={{ fontSize: '14px', color: '#6c757d' }}>
            <span>
              <a href="/dashboard" style={{ color: '#007bff', textDecoration: 'none' }}>Dashboard</a>
              {' > '}
              <a href="/users" style={{ color: '#007bff', textDecoration: 'none' }}>Users</a>
              {' > '}
              <span style={{ color: '#6c757d' }}>
                {getprofiledetails?.first_name && getprofiledetails?.last_name 
                  ? FirstLetterCapital(`${getprofiledetails.first_name} ${getprofiledetails.last_name}`)
                  : 'User Details'
                }
              </span>
            </span>
          </nav>
        </div>
      </div>

      <div style={{ 
        padding: '24px', 
        background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdfa 50%, #ffffff 100%)', 
        minHeight: '100vh' 
      }}>
        {/* Main Content Card */}
        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '16px', 
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          border: '1px solid #d1fae5',
          overflow: 'hidden'
        }}>
          {/* Page Header */}
          <div style={{ 
            background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
            padding: '32px 40px',
            color: 'white'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{
                width: '56px',
                height: '56px',
                borderRadius: '16px',
                backgroundColor: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="fas fa-user-circle" style={{ fontSize: '28px' }}></i>
              </div>
              <div>
                <h1 style={{ margin: '0 0 8px 0', fontSize: '28px', fontWeight: '700' }}>User Details</h1>
                <p style={{ margin: 0, fontSize: '16px', opacity: 0.9 }}>
                  Comprehensive user profile and account management
                </p>
              </div>
            </div>
          </div>

          <div style={{ padding: '40px' }}>
            {/* User Profile Card */}
            <div style={{ 
              backgroundColor: 'white', 
              padding: '32px', 
              borderRadius: '16px', 
              marginBottom: '32px',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '24px', marginBottom: '24px' }}>
                <div 
                  style={{ position: 'relative', cursor: 'pointer' }}
                  onClick={() => handleImageClick(
                    getOptimizedImageUrl(getprofiledetails?.profile_picture, 'PROFILE_FULL') || '/default-avatar.png',
                    `${getprofiledetails?.first_name || ''} ${getprofiledetails?.last_name || ''} Profile Picture`
                  )}
                  title="Click to enlarge image"
                >
                  <img
                    src={getOptimizedImageUrl(getprofiledetails?.profile_picture, 'AVATAR_LARGE') || '/default-avatar.png'}
                    alt="profile"
                    style={{ 
                      width: '100px', 
                      height: '100px', 
                      borderRadius: '20px', 
                      objectFit: 'cover',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      border: '4px solid #fff',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.05)';
                      e.target.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)';
                    }}
                  />
                  {/* Zoom indicator */}
                  <div style={{
                    position: 'absolute',
                    bottom: '4px',
                    right: '4px',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <i className="fas fa-search-plus" style={{ color: 'white', fontSize: '10px' }}></i>
                  </div>
                </div>
                
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                    <h2 style={{ margin: 0, color: '#212529', fontSize: '24px', fontWeight: '700' }}>
                      {FirstLetterCapital(`${getprofiledetails?.first_name || ''} ${getprofiledetails?.last_name || ''}`)}
                    </h2>
                    {getprofiledetails?.shufti_verification && (
                      <div style={{
                        padding: '4px 8px',
                        backgroundColor: '#d4edda',
                        color: '#155724',
                        borderRadius: '12px',
                        fontSize: '12px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <i className="fas fa-shield-check" style={{ fontSize: '10px' }}></i>
                        Verified
                      </div>
                    )}
                  </div>
                  
                  {getprofiledetails?.role && (
                    <div style={{ marginBottom: '16px' }}>
                      <span style={{ 
                        display: 'inline-block', 
                        padding: '6px 16px', 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                        color: 'white', 
                        borderRadius: '20px', 
                        fontSize: '13px',
                        fontWeight: '600'
                      }}>
                        {FirstLetterCapital(getprofiledetails?.role)}
                      </span>
                    </div>
                  )}
                  
                  {/* Contact Information Grid */}
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
                    gap: '16px',
                    marginBottom: '20px'
                  }}>
                    {/* Primary Contact */}
                    <div style={{
                      padding: '16px',
                      backgroundColor: '#fff8e1',
                      borderRadius: '12px',
                      border: '1px solid #ffecb3'
                    }}>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px', 
                        marginBottom: '12px' 
                      }}>
                        <i className="fas fa-star" style={{ color: '#f57c00', fontSize: '14px' }}></i>
                        <span style={{ fontWeight: '600', color: '#e65100', fontSize: '13px' }}>
                          PRIMARY CONTACT
                        </span>
                      </div>
                      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fas fa-envelope" style={{ color: '#f57c00', width: '16px', flexShrink: 0 }}></i>
                        <span style={{ fontSize: '14px', color: '#212529', wordBreak: 'break-word' }}>
                          {getprofiledetails?.email}
                        </span>
                      </div>
                      {getprofiledetails?.phone?.country_code && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <i className="fas fa-phone" style={{ color: '#f57c00', width: '16px', flexShrink: 0 }}></i>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap' }}>
                            <Flag country={Contry(getprofiledetails?.phone?.country_code)} size={16} />
                            <span style={{ whiteSpace: 'nowrap', fontSize: '14px', color: '#212529' }}>
                              {getprofiledetails?.phone?.country_code} {getprofiledetails?.phone?.number}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Alternative Contact */}
                    {(getprofiledetails?.alternative_email || getprofiledetails?.alternative_phone?.country_code) && (
                      <div style={{
                        padding: '16px',
                        backgroundColor: '#e3f2fd',
                        borderRadius: '12px',
                        border: '1px solid #bbdefb'
                      }}>
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: '8px', 
                          marginBottom: '12px' 
                        }}>
                          <i className="fas fa-plus-circle" style={{ color: '#1976d2', fontSize: '14px' }}></i>
                          <span style={{ fontWeight: '600', color: '#0d47a1', fontSize: '13px' }}>
                            ALTERNATIVE CONTACT
                          </span>
                        </div>
                        {getprofiledetails?.alternative_email && (
                          <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fas fa-envelope" style={{ color: '#1976d2', width: '16px', flexShrink: 0 }}></i>
                            <span style={{ fontSize: '14px', color: '#212529', wordBreak: 'break-word' }}>
                              {getprofiledetails.alternative_email}
                            </span>
                          </div>
                        )}
                        {getprofiledetails?.alternative_phone?.country_code && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i className="fas fa-phone" style={{ color: '#1976d2', width: '16px', flexShrink: 0 }}></i>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap' }}>
                              <Flag country={Contry(getprofiledetails.alternative_phone.country_code)} size={16} />
                              <span style={{ whiteSpace: 'nowrap', fontSize: '14px', color: '#212529' }}>
                                {getprofiledetails.alternative_phone.country_code} {getprofiledetails.alternative_phone.number}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Status and Actions */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '12px' }}>
                  <span style={{
                    display: 'inline-block',
                    padding: '8px 16px',
                    backgroundColor: getprofiledetails?.is_active ? '#d4edda' : '#f8d7da',
                    color: getprofiledetails?.is_active ? '#155724' : '#721c24',
                    borderRadius: '20px',
                    fontSize: '13px',
                    fontWeight: '600',
                    border: `1px solid ${getprofiledetails?.is_active ? '#c3e6cb' : '#f5c6cb'}`
                  }}>
                    {getprofiledetails?.is_active ? 'Active' : 'Blocked'}
                  </span>
                  <button
                    style={{
                      padding: '10px 20px',
                      backgroundColor: getprofiledetails?.is_active ? '#dc3545' : '#28a745',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                    onClick={() => {
                      setShowblock(true);
                      settitle(getprofiledetails?.is_active ? 'Block' : 'Activate');
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                  >
                    {getprofiledetails?.is_active ? 'Block User' : 'Activate User'}
                  </button>
                </div>
              </div>
            </div>

            {/* Quick Actions Card */}
            <div style={{ 
              backgroundColor: 'white', 
              padding: '32px', 
              borderRadius: '16px', 
              marginBottom: '32px',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  backgroundColor: '#e8f5e8',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <i className="fas fa-bolt" style={{ color: '#2e7d32', fontSize: '18px' }}></i>
                </div>
                <h3 style={{ margin: 0, color: '#212529', fontSize: '20px', fontWeight: '600' }}>Quick Actions</h3>
              </div>
              
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                <button 
                  onClick={() => navigate(`/booking?search=${encodeURIComponent(getprofiledetails?.email || '')}`)}
                  style={{ 
                    padding: '16px 20px', 
                    background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)', 
                    color: 'white', 
                    border: 'none',
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 8px rgba(0,123,255,0.3)'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0,123,255,0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 8px rgba(0,123,255,0.3)';
                  }}
                >
                  <i className="fas fa-calendar-check"></i>
                  Bookings
                </button>
                
                <button 
                  onClick={() => navigate(`/booking-request-from-care-seeker?search=${encodeURIComponent(getprofiledetails?.email || '')}`)}
                  style={{ 
                    padding: '16px 20px', 
                    background: 'linear-gradient(135deg, #6f42c1 0%, #5a2d91 100%)', 
                    color: 'white', 
                    border: 'none',
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 8px rgba(111,66,193,0.3)'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(111,66,193,0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 8px rgba(111,66,193,0.3)';
                  }}
                >
                  <i className="fas fa-clipboard-list"></i>
                  Booking Requests
                </button>
                
                <button 
                  onClick={() => navigate(`/admin/carers/availability?email=${encodeURIComponent(getprofiledetails?.email || '')}`)}
                  style={{ 
                    padding: '16px 20px', 
                    background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)', 
                    color: 'white', 
                    border: 'none',
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 8px rgba(23,162,184,0.3)'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(23,162,184,0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 8px rgba(23,162,184,0.3)';
                  }}
                >
                  <i className="fas fa-users"></i>
                  Carer Availability
                </button>
                
                <button 
                  onClick={() => navigate(`/notifications?search=${encodeURIComponent(getprofiledetails?.email || '')}`)}
                  style={{ 
                    padding: '16px 20px', 
                    background: 'linear-gradient(135deg, #28a745 0%, #1e7e34 100%)', 
                    color: 'white', 
                    border: 'none',
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 8px rgba(40,167,69,0.3)'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(40,167,69,0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 8px rgba(40,167,69,0.3)';
                  }}
                >
                  <i className="fas fa-bell"></i>
                  Send Notification
                </button>
                
                {/* Edit Contact Dropdown */}
                <div style={{ display: 'flex', alignItems: 'stretch' }}>
                  <EditDropdown onEditContact={handleEditContact} />
                </div>
              </div>
            </div>

          {/* SHUFTI Verification Section */}
          {getprofiledetails?.shufti_verification && (
            <div style={{ marginBottom: '30px' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                marginBottom: '16px',
                padding: '12px 16px',
                backgroundColor: '#e8f5e8',
                borderRadius: '8px',
                border: '1px solid #c3e6c3'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <i className="fas fa-shield-alt" style={{ color: '#16a34a', fontSize: '20px' }}></i>
                  <div>
                    <h4 style={{ margin: '0', color: '#16a34a' }}>SHUFTI Verification</h4>
                    <p style={{ margin: '0', fontSize: '14px', color: '#15803d' }}>
                      User is verified through SHUFTI Pro
                    </p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={handleToggleVerificationSection}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '14px',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                  >
                    <i className={`fas fa-chevron-${showVerificationSection ? 'up' : 'down'}`} style={{ marginRight: '6px' }}></i>
                    {showVerificationSection ? 'Hide Details' : 'View Details'}
                  </button>
                  <button
                    onClick={handleDownloadVerificationData}
                    disabled={downloadLoading}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: downloadLoading ? '#6c757d' : '#28a745',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '14px',
                      cursor: downloadLoading ? 'not-allowed' : 'pointer',
                      transition: 'background-color 0.2s',
                      opacity: downloadLoading ? 0.7 : 1
                    }}
                    onMouseOver={(e) => {
                      if (!downloadLoading) e.target.style.backgroundColor = '#1e7e34';
                    }}
                    onMouseOut={(e) => {
                      if (!downloadLoading) e.target.style.backgroundColor = '#28a745';
                    }}
                  >
                    {downloadLoading ? (
                      <>
                        <i className="fas fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                        Downloading...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-download" style={{ marginRight: '6px' }}></i>
                        Download Data
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Download Error Message */}
              {downloadError && (
                <div style={{
                  padding: '12px',
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  borderRadius: '4px',
                  marginBottom: '16px',
                  border: '1px solid #f5c6cb'
                }}>
                  <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                  {downloadError}
                </div>
              )}

              {/* Download Success Message */}
              {downloadSuccess && (
                <div style={{
                  padding: '12px',
                  backgroundColor: '#d4edda',
                  color: '#155724',
                  borderRadius: '4px',
                  marginBottom: '16px',
                  border: '1px solid #c3e6cb'
                }}>
                  <i className="fas fa-check-circle" style={{ marginRight: '8px' }}></i>
                  Verification data downloaded successfully!
                </div>
              )}

              {/* Verification Details */}
              {showVerificationSection && (
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  border: '1px solid #e9ecef'
                }}>
                  {verificationLoading ? (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                      Loading verification details...
                    </div>
                  ) : verificationError ? (
                    <div style={{
                      padding: '12px',
                      backgroundColor: '#f8d7da',
                      color: '#721c24',
                      borderRadius: '4px',
                      border: '1px solid #f5c6cb'
                    }}>
                      <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                      {verificationError}
                    </div>
                  ) : verificationDetails ? (
                    <div>
                      <h5 style={{ marginBottom: '16px', color: '#333' }}>Verification Summary</h5>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px' }}>
                        <div style={{ padding: '8px', backgroundColor: 'white', borderRadius: '4px' }}>
                          <strong>Status:</strong> 
                          <span style={{ 
                            marginLeft: '8px',
                            color: verificationDetails.user?.shufti_verification ? '#16a34a' : '#dc2626'
                          }}>
                            {verificationDetails.user?.shufti_verification ? 'Verified' : 'Not Verified'}
                          </span>
                        </div>
                        <div style={{ padding: '8px', backgroundColor: 'white', borderRadius: '4px' }}>
                          <strong>Attempts Used:</strong> 
                          <span style={{ marginLeft: '8px' }}>
                            {verificationDetails.current_attempts} / {verificationDetails.max_attempts}
                          </span>
                        </div>
                        {verificationDetails.latest_verification && (
                          <>
                            <div style={{ padding: '8px', backgroundColor: 'white', borderRadius: '4px' }}>
                              <strong>Last Attempt:</strong> 
                              <span style={{ marginLeft: '8px' }}>
                                {new Date(verificationDetails.latest_verification.createdAt).toLocaleDateString()}
                              </span>
                            </div>
                            {verificationDetails.latest_verification.verified_at && (
                              <div style={{ padding: '8px', backgroundColor: 'white', borderRadius: '4px' }}>
                                <strong>Verified On:</strong> 
                                <span style={{ marginLeft: '8px' }}>
                                  {new Date(verificationDetails.latest_verification.verified_at).toLocaleDateString()}
                                </span>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                      
                      {verificationDetails.verification_history && verificationDetails.verification_history.length > 0 && (
                        <div style={{ marginTop: '16px' }}>
                          <h6 style={{ marginBottom: '12px', color: '#333' }}>Verification History</h6>
                          <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white', fontSize: '14px' }}>
                              <thead>
                                <tr style={{ backgroundColor: '#e9ecef' }}>
                                  <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>Date</th>
                                  <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>Status</th>
                                  <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>Reference</th>
                                  <th style={{ padding: '8px', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>Reason</th>
                                </tr>
                              </thead>
                              <tbody>
                                {verificationDetails.verification_history.slice(0, 5).map((record, index) => (
                                  <tr key={index}>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #dee2e6' }}>
                                      {new Date(record.createdAt).toLocaleDateString()}
                                    </td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #dee2e6' }}>
                                      <span style={{
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        fontSize: '12px',
                                        backgroundColor: 
                                          record.status === 'approved' ? '#d4edda' :
                                          record.status === 'rejected' ? '#f8d7da' :
                                          record.status === 'pending' ? '#fff3cd' : '#e2e3e5',
                                        color:
                                          record.status === 'approved' ? '#155724' :
                                          record.status === 'rejected' ? '#721c24' :
                                          record.status === 'pending' ? '#856404' : '#6c757d'
                                      }}>
                                        {FirstLetterCapital(record.status)}
                                      </span>
                                    </td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #dee2e6', fontSize: '12px', fontFamily: 'monospace' }}>
                                      {record.reference}
                                    </td>
                                    <td style={{ padding: '8px', borderBottom: '1px solid #dee2e6' }}>
                                      {record.rejection_reason || '-'}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center', padding: '20px', color: '#6c757d' }}>
                      No verification details available
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

            {/* User Information Card */}
            <div style={{ 
              backgroundColor: 'white', 
              padding: '32px', 
              borderRadius: '16px', 
              marginBottom: '32px',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdfa 100%)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <i className="fas fa-user-circle" style={{ color: 'white', fontSize: '18px' }}></i>
                </div>
                <h3 style={{ margin: 0, color: '#065f46', fontSize: '20px', fontWeight: '600' }}>User Information</h3>
              </div>
              
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '16px' }}>
                {[
                  { 
                    label: 'Primary Email', 
                    value: getprofiledetails?.email || 'N/A',
                    isPrimary: true,
                    icon: 'fas fa-envelope'
                  },
                  { 
                    label: 'Primary Phone', 
                    value: getprofiledetails?.phone?.country_code 
                      ? `${getprofiledetails.phone.country_code} ${getprofiledetails.phone.number}`
                      : 'N/A',
                    isPrimary: true,
                    showFlag: getprofiledetails?.phone?.country_code,
                    icon: 'fas fa-phone'
                  },
                  { 
                    label: 'Gender', 
                    value: FirstLetterCapital(getprofiledetails?.gender) || 'N/A',
                    icon: 'fas fa-venus-mars'
                  },
                  { 
                    label: 'Date of Birth', 
                    value: getprofiledetails?.date_of_birth ? new Date(getprofiledetails?.date_of_birth).toISOString().slice(0, 10) : 'N/A',
                    icon: 'fas fa-birthday-cake'
                  },
                  { 
                    label: 'Age', 
                    value: calculateAge(getprofiledetails?.date_of_birth),
                    icon: 'fas fa-calendar-alt'
                  },
                  { 
                    label: 'Medical Issues', 
                    value: getprofiledetails?.medical_issues?.map(issue => FirstLetterCapital(issue.name)).join(', ') || 'N/A',
                    icon: 'fas fa-heartbeat'
                  },
                  { 
                    label: 'Profession', 
                    value: getprofiledetails?.profession?.name ? FirstLetterCapital(getprofiledetails?.profession?.name) : 'N/A',
                    icon: 'fas fa-briefcase'
                  },
                  { 
                    label: 'Languages', 
                    value: getprofiledetails?.language_preferences?.map(lang => FirstLetterCapital(lang)).join(', ') || 'N/A',
                    icon: 'fas fa-language'
                  },
                  { 
                    label: 'Account Created', 
                    value: getprofiledetails?.createdAt ? new Date(getprofiledetails?.createdAt).toLocaleString() : 'N/A',
                    icon: 'fas fa-user-plus'
                  },
                  { 
                    label: 'Criminal Record', 
                    value: 'No',
                    icon: 'fas fa-shield-alt'
                  },
                  { 
                    label: 'Alternative Email', 
                    value: getprofiledetails?.alternative_email || 'Not provided',
                    isAlternative: true,
                    icon: 'fas fa-envelope'
                  },
                  { 
                    label: 'Alternative Phone', 
                    value: getprofiledetails?.alternative_phone?.country_code 
                      ? `${getprofiledetails.alternative_phone.country_code} ${getprofiledetails.alternative_phone.number}`
                      : 'Not provided',
                    isAlternative: true,
                    showFlag: getprofiledetails?.alternative_phone?.country_code,
                    icon: 'fas fa-phone'
                  },
                ].map((item, idx) => (
                  <div key={idx} style={{ 
                    padding: '20px', 
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    border: item.isAlternative 
                      ? '2px solid #0d9488' 
                      : item.isPrimary 
                        ? '2px solid #059669' 
                        : '1px solid #d1fae5',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.04)';
                  }}
                  >
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '8px', 
                      marginBottom: '8px' 
                    }}>
                      <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '6px',
                        background: item.isAlternative 
                          ? 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)'
                          : item.isPrimary 
                            ? 'linear-gradient(135deg, #059669 0%, #047857 100%)'
                            : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className={item.icon} style={{ color: 'white', fontSize: '10px' }}></i>
                      </div>
                      <div style={{ 
                        fontWeight: '600', 
                        color: '#065f46', 
                        fontSize: '13px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}>
                        {item.label}
                        {item.isAlternative && (
                          <span style={{ 
                            padding: '2px 6px',
                            backgroundColor: '#0d9488',
                            color: 'white',
                            borderRadius: '8px',
                            fontSize: '9px',
                            fontWeight: '600'
                          }}>
                            ALT
                          </span>
                        )}
                        {item.isPrimary && (
                          <span style={{ 
                            padding: '2px 6px',
                            backgroundColor: '#059669',
                            color: 'white',
                            borderRadius: '8px',
                            fontSize: '9px',
                            fontWeight: '600'
                          }}>
                            PRIMARY
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ 
                      color: '#374151', 
                      fontSize: '14px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '6px', 
                      flexWrap: 'nowrap',
                      fontWeight: '500'
                    }}>
                      {item.showFlag && (
                        <Flag country={Contry(item.isPrimary ? getprofiledetails.phone.country_code : getprofiledetails.alternative_phone.country_code)} size={16} />
                      )}
                      <span style={{ 
                        whiteSpace: 'nowrap', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis',
                        lineHeight: '1.4'
                      }}>
                        {item.value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Last Login Information Card */}
            <div style={{ 
              backgroundColor: 'white', 
              padding: '32px', 
              borderRadius: '16px', 
              marginBottom: '32px',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              background: 'linear-gradient(135deg, #ecfdf5 0%, #f0fdfa 100%)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <i className="fas fa-sign-in-alt" style={{ color: 'white', fontSize: '18px' }}></i>
                </div>
                <h3 style={{ margin: 0, color: '#065f46', fontSize: '20px', fontWeight: '600' }}>Last Login Information</h3>
              </div>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
                gap: '20px',
                maxWidth: '600px'
              }}>
                <div style={{
                  padding: '20px',
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  border: '2px solid #10b981',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.04)';
                }}
                >
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    marginBottom: '12px' 
                  }}>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '6px',
                      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <i className="fas fa-globe" style={{ color: 'white', fontSize: '10px' }}></i>
                    </div>
                    <span style={{ fontWeight: '600', color: '#065f46', fontSize: '14px' }}>IP Address</span>
                  </div>
                  <div style={{ 
                    color: '#374151', 
                    fontSize: '16px', 
                    fontWeight: '500',
                    fontFamily: 'monospace',
                    padding: '8px 12px',
                    backgroundColor: '#f0fdf4',
                    borderRadius: '6px',
                    border: '1px solid #bbf7d0'
                  }}>
                    {getprofiledetails?.last_login_ip || 'N/A'}
                  </div>
                </div>

                <div style={{
                  padding: '20px',
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  border: '2px solid #10b981',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                  transition: 'all 0.2s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.04)';
                }}
                >
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px', 
                    marginBottom: '12px' 
                  }}>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '6px',
                      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <i className="fas fa-clock" style={{ color: 'white', fontSize: '10px' }}></i>
                    </div>
                    <span style={{ fontWeight: '600', color: '#065f46', fontSize: '14px' }}>Login Time</span>
                  </div>
                  <div style={{ 
                    color: '#374151', 
                    fontSize: '16px', 
                    fontWeight: '500',
                    padding: '8px 12px',
                    backgroundColor: '#f0fdf4',
                    borderRadius: '6px',
                    border: '1px solid #bbf7d0'
                  }}>
                    {getprofiledetails?.last_login_time ? new Date(getprofiledetails?.last_login_time).toLocaleString() : 'N/A'}
                  </div>
                </div>
              </div>
            </div>

          {/* Documents */}
          <div style={{ marginBottom: '30px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '20px',
              padding: '20px',
              background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
              borderRadius: '12px',
              color: 'white'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                backgroundColor: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="fas fa-file-alt" style={{ fontSize: '18px' }}></i>
              </div>
              <div>
                <h4 style={{ margin: '0 0 4px 0', fontSize: '20px', fontWeight: '600' }}>Documents</h4>
                <p style={{ margin: 0, fontSize: '14px', opacity: 0.9 }}>
                  Manage user verification documents and identity proofs
                </p>
              </div>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '20px' }}>
              {document?.map((doc) => {
                const isPassport = doc.name === 'Passport';
                const hasDocument = isPassport 
                  ? (id_proof != null || getprofiledetails?.id_proof?.picture !== 'https://imgbb.com/')
                  : (address_proof != null || getprofiledetails?.address_proof?.picture !== 'https://imgbb.com/');
                
                return (
                  <div key={doc?._id} style={{ 
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    border: '2px solid #10b981',
                    boxShadow: '0 4px 6px rgba(16,185,129,0.1)',
                    overflow: 'hidden',
                    transition: 'all 0.2s ease'
                  }}>
                    {/* Document Header */}
                    <div style={{
                      padding: '20px',
                      background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
                      borderBottom: '1px solid #d1fae5'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                        <div style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '8px',
                          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <i className={`fas fa-${isPassport ? 'passport' : 'home'}`} style={{ color: 'white', fontSize: '14px' }}></i>
                        </div>
                        <h5 style={{ margin: 0, color: '#065f46', fontSize: '16px', fontWeight: '600' }}>
                          {FirstLetterCapital(doc.name)}
                        </h5>
                      </div>
                      
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          backgroundColor: hasDocument ? '#10b981' : '#f59e0b'
                        }}></div>
                        <span style={{ 
                          fontSize: '14px', 
                          color: hasDocument ? '#065f46' : '#92400e',
                          fontWeight: '500'
                        }}>
                          {hasDocument ? 'Document uploaded' : 'No document uploaded'}
                        </span>
                      </div>
                    </div>

                    {/* Document Actions */}
                    <div style={{ padding: '20px' }}>
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <input
                          type="file"
                          accept="image/*"
                          style={{ display: 'none' }}
                          id={`file-${doc._id}`}
                          onChange={(e) => {
                            doc.name === 'Passport'
                              ? handleidproofUpload(e, doc?._id)
                              : handleaddressproofUpload(e, doc?._id);
                          }}
                        />
                        <label
                          htmlFor={`file-${doc._id}`}
                          style={{
                            padding: '10px 16px',
                            background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
                            color: 'white',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '500',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all 0.2s ease',
                            textDecoration: 'none'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.background = 'linear-gradient(135deg, #047857 0%, #0f766e 100%)';
                            e.target.style.transform = 'translateY(-1px)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.background = 'linear-gradient(135deg, #059669 0%, #0d9488 100%)';
                            e.target.style.transform = 'translateY(0)';
                          }}
                        >
                          <i className="fas fa-upload" style={{ fontSize: '12px' }}></i>
                          Upload
                        </label>
                        
                        <button
                          style={{
                            padding: '10px 16px',
                            backgroundColor: '#6b7280',
                            color: 'white',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '500',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#4b5563';
                            e.target.style.transform = 'translateY(-1px)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#6b7280';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          onClick={() => {
                            const imageUrl = doc.name === 'Passport' 
                              ? (getprofiledetails?.id_proof?.picture || id_proof)
                              : (getprofiledetails?.address_proof?.picture || address_proof);
                            if (imageUrl && imageUrl !== 'https://imgbb.com/') {
                              handleImageClick(getOptimizedImageUrl(imageUrl, 'PROFILE_FULL'), `${doc.name} Document`);
                            }
                          }}
                        >
                          <i className="fas fa-eye" style={{ fontSize: '12px' }}></i>
                          View
                        </button>
                        
                        <button
                          style={{
                            padding: '10px 16px',
                            backgroundColor: '#dc2626',
                            color: 'white',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '500',
                            border: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#b91c1c';
                            e.target.style.transform = 'translateY(-1px)';
                          }}
                          onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#dc2626';
                            e.target.style.transform = 'translateY(0)';
                          }}
                          onClick={() => {
                            setShow(true);
                            setInfoId(doc?._id);
                            setType(doc.name === 'Passport' ? 'Passport' : 'Address');
                          }}
                        >
                          <i className="fas fa-trash" style={{ fontSize: '12px' }}></i>
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Email History - Lazy Loaded */}
          <div style={{ marginBottom: '30px' }}>
            <div style={{ 
              background: 'white',
              borderRadius: '12px',
              border: '2px solid #10b981',
              boxShadow: '0 4px 6px rgba(16,185,129,0.1)',
              overflow: 'hidden'
            }}>
              {/* Email History Header */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px',
                background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
                borderBottom: '1px solid #d1fae5'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <i className="fas fa-envelope" style={{ color: 'white', fontSize: '18px' }}></i>
                  </div>
                  <div>
                    <h4 style={{ margin: '0 0 4px 0', color: '#065f46', fontSize: '18px', fontWeight: '600' }}>
                      Email History
                    </h4>
                    <p style={{ margin: 0, fontSize: '14px', color: '#047857' }}>
                      View all emails sent to this user and delivery events
                    </p>
                  </div>
                </div>
                
                <button
                  onClick={() => setShowEmailHistory(!showEmailHistory)}
                  style={{
                    padding: '12px 20px',
                    background: showEmailHistory 
                      ? 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)'
                      : 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onMouseOver={(e) => {
                    if (!showEmailHistory) {
                      e.target.style.background = 'linear-gradient(135deg, #047857 0%, #0f766e 100%)';
                      e.target.style.transform = 'translateY(-1px)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!showEmailHistory) {
                      e.target.style.background = 'linear-gradient(135deg, #059669 0%, #0d9488 100%)';
                      e.target.style.transform = 'translateY(0)';
                    }
                  }}
                >
                  <i className={`fas fa-${showEmailHistory ? 'eye-slash' : 'envelope-open'}`}></i>
                  {showEmailHistory ? 'Hide Email History' : 'View Email History'}
                </button>
              </div>
              
              {showEmailHistory && (
                <div style={{ padding: '20px' }}>
                  <EmailHistorySection 
                    userId={id} 
                    userName={`${getprofiledetails?.first_name || ''} ${getprofiledetails?.last_name || ''}`.trim() || 'User'}
                    userEmail={getprofiledetails?.email}
                  />
                </div>
              )}
            </div>
          </div>
          </div>

          {/* User Activity */}
          {/* Recent Bookings */}
          <div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '20px',
              padding: '20px',
              background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
              borderRadius: '12px',
              color: 'white'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                backgroundColor: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <i className="fas fa-calendar-check" style={{ fontSize: '18px' }}></i>
              </div>
              <div>
                <h4 style={{ margin: '0 0 4px 0', fontSize: '20px', fontWeight: '600' }}>Recent Bookings</h4>
                <p style={{ margin: 0, fontSize: '14px', opacity: 0.9 }}>
                  Latest booking activities and travel requests
                </p>
              </div>
            </div>
            
            {bookingsLoading ? (
              <div style={{ 
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '2px solid #10b981',
                padding: '40px',
                textAlign: 'center'
              }}>
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '12px',
                  color: '#059669',
                  fontSize: '16px'
                }}>
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: '20px' }}></i>
                  Loading bookings...
                </div>
              </div>
            ) : userBookings.length === 0 ? (
              <div style={{ 
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '2px solid #d1fae5',
                padding: '40px',
                textAlign: 'center'
              }}>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '12px'
                }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: '#f0fdf4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <i className="fas fa-calendar-times" style={{ fontSize: '24px', color: '#6b7280' }}></i>
                  </div>
                  <div>
                    <h5 style={{ margin: '0 0 4px 0', color: '#374151', fontSize: '16px' }}>No bookings found</h5>
                    <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>
                      This user hasn't made any bookings yet.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ 
                backgroundColor: 'white',
                borderRadius: '12px',
                border: '2px solid #10b981',
                boxShadow: '0 4px 6px rgba(16,185,129,0.1)',
                overflow: 'hidden'
              }}>
                {/* Bookings Header */}
                <div style={{
                  padding: '20px',
                  background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
                  borderBottom: '1px solid #d1fae5'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <i className="fas fa-list" style={{ color: '#059669', fontSize: '16px' }}></i>
                      <span style={{ color: '#065f46', fontWeight: '600', fontSize: '16px' }}>
                        {userBookings.length} Booking{userBookings.length !== 1 ? 's' : ''} Found
                      </span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#047857' }}>
                      Showing recent activity
                    </div>
                  </div>
                </div>

                {/* Bookings List */}
                <div style={{ padding: '20px' }}>
                  <div style={{ display: 'grid', gap: '16px' }}>
                    {userBookings.map((booking, index) => (
                      <div key={booking._id} style={{
                        padding: '20px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '10px',
                        border: '1px solid #e2e8f0',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#f0fdf4';
                        e.currentTarget.style.borderColor = '#bbf7d0';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(16,185,129,0.15)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#f8fafc';
                        e.currentTarget.style.borderColor = '#e2e8f0';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', alignItems: 'center' }}>
                          {/* Booking ID */}
                          <div>
                            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px', fontWeight: '500' }}>
                              Booking ID
                            </div>
                            <div style={{ 
                              fontSize: '14px', 
                              fontWeight: '600', 
                              color: '#059669',
                              fontFamily: 'monospace'
                            }}>
                              {booking.booking_number}
                            </div>
                          </div>

                          {/* Booking Date */}
                          <div>
                            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px', fontWeight: '500' }}>
                              Booking Date
                            </div>
                            <div style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                              {booking.createdAt ? new Date(booking.createdAt).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                              }) : 'N/A'}
                            </div>
                          </div>

                          {/* Status */}
                          <div>
                            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px', fontWeight: '500' }}>
                              Status
                            </div>
                            <div style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px',
                              padding: '4px 10px',
                              borderRadius: '20px',
                              fontSize: '12px',
                              fontWeight: '600',
                              backgroundColor: booking.booking_status === 'payment_confirmed' ? '#dcfce7' : '#fef3c7',
                              color: booking.booking_status === 'payment_confirmed' ? '#166534' : '#92400e'
                            }}>
                              <div style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                backgroundColor: booking.booking_status === 'payment_confirmed' ? '#16a34a' : '#f59e0b'
                              }}></div>
                              {booking.booking_status?.replace('_', ' ').toUpperCase()}
                            </div>
                          </div>

                          {/* Departure Date */}
                          <div>
                            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px', fontWeight: '500' }}>
                              Departure Date
                            </div>
                            <div style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                              {booking.flight_details?.departure_date ? new Date(booking.flight_details.departure_date).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                              }) : 'N/A'}
                            </div>
                          </div>

                          {/* Actions */}
                          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <a 
                              href={`/booking-details/${booking._id}`} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              style={{
                                padding: '8px 16px',
                                background: 'linear-gradient(135deg, #059669 0%, #0d9488 100%)',
                                color: 'white',
                                borderRadius: '8px',
                                textDecoration: 'none',
                                fontSize: '13px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'all 0.2s ease'
                              }}
                              onMouseOver={(e) => {
                                e.target.style.background = 'linear-gradient(135deg, #047857 0%, #0f766e 100%)';
                                e.target.style.transform = 'translateY(-1px)';
                              }}
                              onMouseOut={(e) => {
                                e.target.style.background = 'linear-gradient(135deg, #059669 0%, #0d9488 100%)';
                                e.target.style.transform = 'translateY(0)';
                              }}
                            >
                              <i className="fas fa-external-link-alt" style={{ fontSize: '12px' }}></i>
                              View Details
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Modals */}
          <DeleteModal
            show={show}
            handleClose={() => setShow(false)}
            handleDelete={handleDelete}
          />
          <BlockModal
            show={showblock}
            title={title}
            handleClose={() => setShowblock(false)}
            handleBlockActive={handleBlockActive}
          />
          <ImageModal
            show={showImageModal}
            imageUrl={selectedImage.url}
            altText={selectedImage.alt}
            onClose={() => setShowImageModal(false)}
          />
          <AlternativeContactModal
            show={showAlternativeContactModal}
            user={getprofiledetails}
            editType={contactEditType}
            onClose={() => setShowAlternativeContactModal(false)}
            onSuccess={() => {
              // Refresh user data after successful update
              dispatch(getprofiledetail({ id }));
            }}
          />
        </div>
      </div>
    </Layout>
  );
}